//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FormBox',
  data: function data() {
    return {
      timeVal: [this.$moment().subtract(30, 'days').format('YYYY/MM/DD'), this.$moment(new Date()).format('YYYY/MM/DD')],
      pickerOptions: this.$pickerOptionsTimeEle,
      tableFrom: {
        time: this.$moment().subtract(30, 'days').format('YYYY/MM/DD') + '-' + this.$moment(new Date()).format('YYYY/MM/DD'),
        type: ''
      }
    };
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.lang;
    }
  },
  watch: {
    lang: function lang() {
      this.setOptions();
    }
  },
  methods: {
    setOptions: function setOptions() {},
    selectType: function selectType() {
      this.confirmData();
    },
    reset: function reset() {
      this.timeVal = [this.$moment().subtract(30, 'days').format('YYYY/MM/DD'), this.$moment(new Date()).format('YYYY/MM/DD')];
      this.tableFrom.time = this.$moment().subtract(30, 'days').format('YYYY/MM/DD') + '-' + this.$moment(new Date()).format('YYYY/MM/DD'), this.confirmData();
    },
    // 选择时间区域
    onchangeTime: function onchangeTime(e) {
      if (e == null) {
        this.tableFrom.time = '';
        this.confirmData();
      } else {
        this.timeVal = e;
        this.tableFrom.time = this.timeVal[0] + '-' + this.timeVal[1];
        this.confirmData();
      }
    },
    confirmData: function confirmData() {
      this.$emit('confirmData', this.tableFrom);
    }
  }
};